import { render, staticRenderFns } from "./Revista.vue?vue&type=template&id=021f6584&scoped=true"
import script from "./Revista.vue?vue&type=script&lang=js"
export * from "./Revista.vue?vue&type=script&lang=js"
import style0 from "./Revista.vue?vue&type=style&index=0&id=021f6584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021f6584",
  null
  
)

export default component.exports